<template>
  <div>
    <div class="order_msg" v-if="info.status == 'SUCCESS'">
      <div class="order_text_area">
        <img src="@/assets/agreement/complete.png">
        <h2 class="order_msg_title order_msg_success">{{status[info.status]}}</h2>
      </div>
      <div class="order_items_area">
        <div class="order_item_area">
          <div class="order_item_hd">支付编号</div>
          <div class="order_item_bd" id="orderNo">{{ info.tradeOrderNo }}</div>
        </div>
        <div class="order_item_area">
          <div class="order_item_hd">服务号</div>
          <div class="order_item_bd" id="amount">{{ info.insuranceNo }}</div>
        </div>
        <div class="order_item_area">
          <div class="order_item_hd">支付方式</div>
          <div class="order_item_bd" id="amount">{{ payWayObj[info.payWay] }}</div>
        </div>
        <div class="order_item_area">
          <div class="order_item_hd">支付金额</div>
          <div class="order_item_bd" id="amount">{{ info.amount }} 元</div>
        </div>
        <!-- <div class="order_item_area">
          <div class="order_item_hd">客户类型</div>
          <div class="order_item_bd" id="amount">{{ info.customerType == '1' ? '个人' : '公司' }}</div>
        </div>
        <div class="order_item_area">
          <div class="order_item_hd">客户姓名</div>
          <div class="order_item_bd" id="amount">{{ info.customerName }}</div>
        </div> -->
        <div class="order_item_area">
          <div class="order_item_hd">下单时间</div>
          <div class="order_item_bd" id="amount">{{ info.tradeTime }}</div>
        </div>
      </div>
    </div>
    <div v-else class="order_msg">
      <div class="order_text_area">
        <img src="@/assets/agreement/complete.png">
        <h2 class="order_msg_title order_msg_success">{{status[info.status]}}</h2>
      </div>
      <div class="msg">
        <span>订单号：{{ info.tradeOrderNo }}, 服务号：{{ info.insuranceNo }}, {{status[info.status]}}！</span><br>
        <span v-if="info.respMag">原因：{{ info.respMag }} 。</span>
      </div>
      <div class="text-center">
      </div>
    </div>
    <div class="text-center" v-if="info.status == 'NOTPAY' || info.status == 'UNKNOW'">
      <van-button class="btn-get" @click="toPay">前往支付</van-button>
    </div>
  </div>
</template>
<script>
  import {
  queryOrder
} from "@/api/extendedWarranty";
import { installmentStep } from "@/api/sign";
  import storage from '@/utils/storage'
  export default {
    data() {
      return {
        insuranceNo: '',
        info: {},
        status: {
            UNKNOW: '未支付',
            NOTPAY: '未支付',
            SUCCESS: '支付成功',
            FAIL: '支付失败',
            RUSH: '支付已冲正',
            REVOKED: '支付已撤销',
        },
        payWayObj: {
          wxH5: '微信支付',
          alipayH5: '支付宝支付',
          alipayHuabei: '支付宝（花呗分期）',
          unionPayInst: '银联支付（分期）',
        }
       }
    },
    created() {
        this.insuranceNo = this.$route.query.insuranceNo
        this.installmentStep()
      this.queryOrder()
    },
    methods: {
      async installmentStep() {
        // 1-待完成付首付款；2-待确认分期信息；3-待签署分期协议；4-待绑定银行卡；9-分期签署已完成。
        let res = await installmentStep({ orderNo: this.insuranceNo });
        // if (!res.success) {
        //   this.$toast.fail(res.respMag);
        //   return;
        // }
        this.stepInfo = res;
        if (this.stepInfo.installment == 1) {
          if (this.stepInfo.installmentSteps == 1) {
            this.$router.replace({
              path: "/pay/index",
              query: { insuranceNo: this.insuranceNo },
            });
          } else {
            this.$router.replace({
              path: "/pay/sign",
              query: { insuranceNo: this.insuranceNo },
            });
          }
        }
      },
      async queryOrder() {
        let parms = {}
        if(this.$route.query.insuranceNo){
          parms = {insuranceNo: this.$route.query.insuranceNo}
        }else if(this.$route.query.tradeOrderNo){
          parms = {insuranceNo: this.$route.query.tradeOrderNo}
        }
        const res = await queryOrder(parms)
        if (res.success) {
          this.info = res.content
        } else {
          this.$toast(res.respMag)
        }
      },
      toPay(){
        this.$router.replace({
          path: "/pay/index",
          query: { insuranceNo: this.insuranceNo },
        });
      }
    }
  }
</script>
<style scoped>
  * {
    padding: 0;
    margin: 0;
    border: 0;
    outline: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    -webkit-touch-callout: none;
    -webkit-appearance: none !important;
    -webkit-tap-highlight-color: transparent;
  }

  html,
  body {
    position: relative;
    max-width: 12.8rem;
    height: 100%;
    min-height: 100%;
    margin: 0rem auto;
    font-size: 0.32rem;
    font-family: -apple-system-font, Helvetica Neue, Helvetica, sans-serif;
    color: #111;
    background-color: #fff;
  }

  .btn-get {
    width: 80%;
    height: 1rem;
    line-height: 1rem;
    -moz-border-radius: 0.06rem;
    border-radius: 0.6rem;
    font-size: 0.4rem;
    color: #f4fff7;
    text-align: center;
    background-color: #39af5a;
    border: none;
    outline: 0;
    letter-spacing: 0.1rem;
  }

  .order_msg {
    padding-top: 2rem;
    text-align: center;
  }

  .order_text_area {
    margin-bottom: 1rem;
    padding: 0 1.3rem;
  }

  .order_text_area img {
    width: 1.6rem;
  }

  .order_msg_title {
    line-height: 1.6;
    margin-bottom: 0.4rem;
    font-weight: bold;
    font-size: 1.4rem;
    color: #098AE1;
    margin-top: 0.2rem;
  }

  .order_msg_success {
    line-height: 1.6;
    font-size: 0.6rem;
    color: #999;
  }

  .order_items_area {
    margin: 0.5rem 1rem;
    padding: 0.5rem 0;
    border-top: 1px solid #eee;
  }

  .order_item_area {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    /* line-height: 93.75px; */
    font-size: 0.5rem;
    text-align: left;
    margin-bottom: 4px;
  }

  .order_item_hd {
    width: 3rem;
    color: #666;
    font-size: 0.4rem;
  }

  .order_item_bd {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    color: #333;
    font-size: 0.4rem;
  }

  .text-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media screen and (min-height:0rem) and (max-height:8.98rem) {
    html {
      font-size: 0.18rem;
    }
  }

  @media screen and (min-height:9rem) and (max-height:9.98rem) {
    html {
      font-size: 0.2rem;
    }
  }

  @media screen and (min-height:10rem) and (max-height:10.98rem) {
    html {
      font-size: 0.22rem;
    }
  }

  @media screen and (min-height:11rem) and (max-height:11.98rem) {
    html {
      font-size: 0.24rem;
    }
  }

  @media screen and (min-height:12rem) and (max-height:12.98rem) {
    html {
      font-size: 0.26rem;
    }
  }

  @media screen and (min-height:13rem) and (max-height:13.98rem) {
    html {
      font-size: 0.29rem;
    }
  }

  @media screen and (min-height:14rem) and (max-height:14.98rem) {
    html {
      font-size: 0.32rem;
    }
  }

  @media screen and (min-height:15rem) and (max-height:15.98rem) {
    html {
      font-size: 0.33rem;
    }
  }

  @media screen and (min-height:16rem) and (max-height:16.98rem) {
    html {
      font-size: 0.35rem;
    }
  }

  @media screen and (min-height:17rem) and (max-height:17.98rem) {
    html {
      font-size: 0.37rem;
    }
  }

  @media screen and (min-height:18rem) and (max-height:18.98rem) {
    html {
      font-size: 0.39rem;
    }
  }

  @media screen and (min-height:19rem) and (max-height:19.98rem) {
    html {
      font-size: 0.41rem;
    }
  }

  @media screen and (min-height:20rem) and (max-height:25.6rem) {
    html {
      font-size: 0.42rem;
    }
  }

  @media (min-height:25.62rem) {
    html {
      font-size: 0.44rem;
    }
  }
  .msg {
    font-size: 0.42667rem;
    color: #333;
    display: flex;
    flex-direction: column;
    align-items: start;
    margin-left: 30px;
  }
</style>
